import { useParams } from "react-router-dom";
import { ModalComponentProps } from "../../../types";
import AdjustmentLog from "../../Settings/Leave/AdjustmentLog";
import CustomModal from "../../ui/CustomModal";

export default function AdjustmentLogModal({
  data,
  handleClose,
  ...rest
}: ModalComponentProps<number | undefined>) {
  const { viewId } = useParams();

  return (
    <CustomModal
      title="Adjustment Log"
      {...rest}
      handleClose={handleClose}
      width={700}
      footer={null}
    >
      <AdjustmentLog
        businessMemberId={viewId}
        leaveTypeId={data}
        className="min-h-[100px]"
      />
    </CustomModal>
  );
}
